import { METHOD } from 'services/method'

export const API_BENEFIT_REDEEM_POINT = {
    LIST: {
        api: '/v1/dashboard-admin/loyalty-program/benefit/list',
        method: METHOD.POST,
    },
    PRODUCT_LIST: {
        api: '/v1/dashboard-admin/loyalty-program/benefit/product',
        method: METHOD.GET,
    },
    GIFT_LIST: {
        api: '/v1/dashboard-admin/loyalty-program/benefit/gift',
        method: METHOD.GET,
    },
    CREATE: {
        api: '/v1/dashboard-admin/loyalty-program/benefit',
        method: METHOD.POST,
    },
    UPDATE: {
        api: '/v1/dashboard-admin/loyalty-program/benefit',
        method: METHOD.PUT,
    },
    DELETE: {
        api: '/v1/dashboard-admin/loyalty-program/benefit/delete',
        method: METHOD.POST,
    },
}
